// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__3eVzH","loaderOuter":"PageOverlayLoader_loaderOuter__1qGut"};